var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex form-check-box"},[_c('label',{class:[{ 'checked' : _vm.value}, _vm.position]},[_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }